export default __webpack_public_path__ + "static/homepageHero-447c13b23129174a70684035f3492494.png";